import i18n from '../i18n';

export function validateExpenseForm(values) {
  const errors = {};
  if (!values.name?.trim()) errors.name = i18n.t('expenses:validation.nameRequired');
  if (!values.amount || Number(values.amount) <= 0) errors.amount = i18n.t('expenses:validation.amountPositive');
  if (!values.category) errors.category = i18n.t('expenses:validation.categoryRequired');
  if (!values.date) errors.date = i18n.t('expenses:validation.dateRequired');
  return errors;
}

export function validateGoalForm(values) {
  const errors = {};
  if (!values.title?.trim()) errors.title = i18n.t('goals:validation.titleRequired');
  if (!values.startDate) errors.startDate = i18n.t('goals:validation.startDateRequired');
  if (!values.endDate) errors.endDate = i18n.t('goals:validation.endDateRequired');
  if (values.targetAmount && Number(values.targetAmount) <= 0) errors.targetAmount = i18n.t('goals:validation.targetAmountPositive');
  return errors;
}

export function validateChecklistForm(values) {
  const errors = {};
  if (!values.title?.trim()) errors.title = i18n.t('checklist:validation.titleRequired');
  if (!values.date) errors.date = i18n.t('checklist:validation.dateRequired');
  return errors;
}
